import React, { memo } from 'react';
import { MdOutlineAccountBalance } from 'react-icons/md';
import useTenantTranslation from 'utils/hooks/useTenantTranslation';
import './style.scss';
import { numericFormatter } from 'react-number-format';

type CRFCardExpandedViewProps = {
  data: {
    logo?: string;
    partnerName: string;
    description?: string;
    languages?: string;
    amountFinancedToDate?: string | number;
    smallBusinessesServed?: string | number;
    areasServed?: string;
    headquarters?: string;
    establishedYear?: number;
  };
};

const CRFCardExpandedView: React.FC<CRFCardExpandedViewProps> = ({ data }) => {
  const { t } = useTenantTranslation();

  if (!data) return null;

  const {
    partnerName,
    languages,
    amountFinancedToDate,
    smallBusinessesServed,
    areasServed,
    headquarters,
    establishedYear,
  } = data;

  return (
    <div className="crf_card_modal_container">
      <div className="crf_card">
        <div className="crf_card_header">
          <div className="crf_card_header_text">{partnerName}</div>
        </div>
        <div className="crf_card_body_wrapper">
          <div className="crf_card_body">
            {languages && (
              <div className="crf_card_item">
                <p className="crf_card_item__title">
                  {t('funding_module.crf_expanded_view.languages')}
                </p>
                <p className="crf_card_item__value">{languages}</p>
              </div>
            )}
            {amountFinancedToDate !== undefined && (
              <div className="crf_card_item">
                <p className="crf_card_item__title">
                  {t(
                    'funding_module.crf_expanded_view.amount_financed_to_date',
                  )}
                </p>
                <p className="crf_card_item__value">
                  {String(amountFinancedToDate)}
                </p>
              </div>
            )}
            {smallBusinessesServed !== undefined && (
              <div className="crf_card_item">
                <p className="crf_card_item__title">
                  {t(
                    'funding_module.crf_expanded_view.small_businesses_served',
                  )}
                </p>
                <p className="crf_card_item__value">
                  {numericFormatter(smallBusinessesServed.toString(), {
                    thousandSeparator: ',',
                    prefix: '',
                  })}
                </p>
              </div>
            )}
            {headquarters && (
              <div className="crf_card_item">
                <p className="crf_card_item__title">
                  {t('funding_module.crf_expanded_view.headquarters')}
                </p>
                <p className="crf_card_item__value">{headquarters}</p>
              </div>
            )}
            {/* {establishedYear && (
              <div className="crf_card_item">
                <p className="crf_card_item__title">
                  {t('funding_module.crf_expanded_view.established_year')}
                </p>
                <p className="crf_card_item__value">{establishedYear}</p>
              </div>
            )} */}
            {areasServed && (
              <div className="crf_card_item">
                <p className="crf_card_item__title">
                  {t('funding_module.crf_expanded_view.areas_served')}
                </p>
                <p className="crf_card_item__value">{areasServed}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(CRFCardExpandedView);
